import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const helmetSeoSelectors = [
  'link[rel="canonical"][data-react-helmet="true"]',
  'meta[name="title"][data-react-helmet="true"]',
  'meta[name="description"][data-react-helmet="true"]',
  'meta[name="keywords"][data-react-helmet="true"]',
  'meta[name="robots"][data-react-helmet="true"]',
  'meta[name="author"][data-react-helmet="true"]',
  'meta[name="content-type"][data-react-helmet="true"]',
  'meta[name^="twitter:"][data-react-helmet="true"]',
  'meta[property^="og:"][data-react-helmet="true"]',
  'script[type="application/ld+json"][data-react-helmet="true"]'
];

const clearHelmetSeoTags = () => {
  for (const selector of helmetSeoSelectors) {
    document.head.querySelectorAll(selector).forEach(node => node.remove());
  }
};

const ClearHelmetSeoOnNavigation = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    clearHelmetSeoTags();
  }, [location.key]);

  return null;
};

export default ClearHelmetSeoOnNavigation;
